import React from 'react'
import { observer,inject } from 'mobx-react'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import { CircularProgress } from 'material-ui/Progress'
import List, {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
} from 'material-ui/List'
import Avatar from 'material-ui/Avatar'

import { withLayout } from '../utils/hoc'
import { withStyles } from 'material-ui/styles'
import { Link } from 'react-router-dom'
import Grid from 'material-ui/Grid'
import T from 'i18n-react'
import { withRouter } from 'react-router'
import { AddToCartButton } from './cart'
import Tooltip from 'material-ui/Tooltip'
import route from '../stores/fetchconfig.json'


@inject('store') @withRouter @observer
class ExampleDetails extends React.Component {
  render () {
    const { classes, store } = this.props, link = store.itemToInspect ? store.itemToInspect.link : ""

    return (
      <div>
       <ExampleDetailsHeader classes={classes} link={link} />
       <ExampleContent classes={classes} item={store.itemToInspect} link={link} />
      </div>
    )
  }

  componentWillMount () {
   this.props.store.getSettings()
   this.props.store.getItemDetails(this.props.match.params.id)
  }

  componentWillReceiveProps(nextProps) {
   if (this.props.location !== nextProps.location) {
    this.props.store.getItemDetails(nextProps.match.params.id)
   }
  }

}

@inject('store') @observer
class ExampleDetailsHeader extends React.Component {
  render () {
    const { classes,link } = this.props

    return (
      <AppBar className={classNames(classes.appBar)} position="fixed">
        <Toolbar disableGutters={true}>

         <Link to={route.endpoint + "/"} className={"unstyle-a " + classNames(classes.flex)} onClick={this.handleClick}>
          <IconButton color="inherit">
           <Icon>arrow_back</Icon>
          </IconButton>
         </Link>

         {link &&
          <Button color="inherit" href={link}>
           <Icon>exit_to_app</Icon> <span style={{paddingLeft:5}}> {T.translate('detail.toWebsite')} </span>
          </Button>
         }

        </Toolbar>
      </AppBar>
    )
  }
}

@inject('store','ui') @observer
class ExampleContent extends React.Component {
  render () {
    const  { classes,item,ui,store,link } = this.props

    return (
      <main className={classNames(classes.content)} style={{padding:0}}>
      {!item && <CircularProgress className="center-center" size={70} />}
      {item &&
       <Grid container spacing={0}>

        <Grid item xs={12} className="item-detail-add-to-cart">
         <Grid container direction="row" justify="flex-end" spacing={0}>
          <AddToCartButton atDetailView={true} item={item} />
         </Grid>
        </Grid>

        <Grid item xs={12} sm={4} className="item-detail-spacing">
         <a href={link} className="unstyle-a"><img src={item.image} className="item-detail-image" alt={item.title} /></a>
        </Grid>
        <Grid item xs={12} sm={8} className="item-detail-spacing">
         <a className="unstyle-a" href={link}>
          <Typography type="headline" gutterBottom> {item.title} </Typography>
          <Typography component="p"> {item.description} </Typography>
         </a>

        </Grid>

        <Grid item xs={12}>
         <Grid container spacing={0} className={classes.metaDetailsContainer}>
          <Grid item xs={4} className="center-flex">
           {item.zyklus1 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "1"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-1">1</Avatar></Tooltip>}
           {item.zyklus2 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "2"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-2">2</Avatar></Tooltip>}
           {item.zyklus3 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "3"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-3">3</Avatar></Tooltip>}
          </Grid>
          <Grid item xs={4} className="catalog-item-lessons center-flex">
           <Typography> {item.type.name} </Typography>
          </Grid>
          <Grid item xs={4} className="catalog-item-lessons center-flex">
           <Typography> {store.getApproximatedTimevalue(item)} </Typography>
          </Grid>
         </Grid>
        </Grid>

        {item.kompetenzstufen.length > 0 &&
          <Grid item xs={12}>
           <Grid container direction="row" justify="flex-end" spacing={0}>
            <List className={classes.list} subheader={<ListSubheader> {T.translate("detail.compSteps")} </ListSubheader>}>
             {
              item.kompetenzstufen.map( (ks,index) => {
               return (
                 <ListItem key={index} dense button divider={true}>
                  <Avatar className={ui.getZyklusColor(ks)}> {ui.getZyklusAsString(ks)} </Avatar>
                  <ListItemText primary={ks.kompetenzstufe} secondary={ks.code}/>
                  <ListItemSecondaryAction>
                   <IconButton aria-label="add">
                    <Icon>plus</Icon>
                   </IconButton>
                  </ListItemSecondaryAction>
                 </ListItem>
               )
              })
             }
            </List>
           </Grid>
          </Grid>
        }

       </Grid>
      }
      </main>
    )
  }
}


const styles = theme => ({
  appBar: {
    position: 'fixed',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  content: {
    width: '100%',
    overflow:'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 64px)',
    marginTop: 64,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 64,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft:0,
    },
  },
  flex: {
    flex: 1,
  },
  metaDetailsContainer:{
    paddingTop:10,
    paddingBottom:10,
    borderTop:'1px solid #eee',
    borderBottom:'1px solid #eee'
  },
  list:{
    'overflow-x':'hidden'
  }
})

ExampleDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}


export default withStyles(styles, { withTheme: true })(withLayout(ExampleDetails))



// WEBPACK FOOTER //
// ./src/components/exampledetails.js